import { Link } from 'react-router-dom';

const ProductsSection = () => {
  const products = [
    {
      image: 'https://public.readdy.ai/ai/img_res/57634d444d783624032b57cf6a2eb1f3.jpg',
      name: 'チタン製特注ネジ',
      specs: 'M3×10mm / 0.01mm精度',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=stainless%20steel%20precision%20bolt%20with%20hexagonal%20head%20on%20clean%20white%20background%2C%20macro%20close-up%20showing%20mirror-polished%20surface%20and%20perfect%20threading%2C%20industrial%20product%20photography%2C%20professional%20studio%20lighting%2C%20high-precision%20manufacturing%20quality%20visible%20in%20details&width=400&height=400&seq=product-002&orientation=squarish',
      name: 'ステンレス精密ボルト',
      specs: 'M5×15mm / 難削材対応',
    },
    {
      image: 'https://readdy.ai/api/search-image?query=custom-shaped%20precision%20screw%20with%20unique%20thread%20design%20on%20clean%20white%20background%2C%20macro%20photography%20showing%20special%20geometric%20pattern%20and%20ultra-fine%20machining%20details%2C%20industrial%20product%20shot%2C%20professional%20lighting%20emphasizing%20metal%20craftsmanship%20and%20precision%20engineering&width=400&height=400&seq=product-003&orientation=squarish',
      name: '特殊形状ネジ',
      specs: '完全オーダーメイド / 1本から対応',
    },
    {
      image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/dfed94c451ee5fe9b84358aadc7c9ff4.jpeg',
      name: 'インコネル製ファスナー',
      specs: '耐熱性 / 航空宇宙品質',
    },
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-28 bg-navy">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white text-center mb-4 sm:mb-6">
          加工事例
        </h2>
        <p className="text-base sm:text-lg text-white/80 text-center mb-10 sm:mb-12 lg:mb-16 max-w-3xl mx-auto">
          岡山市の町工場として、様々な特注ネジ・難削材加工に対応してきました
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8" data-product-shop>
          {products.map((product, index) => (
            <div
              key={index}
              className="bg-white border-2 border-navy rounded-2xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 group cursor-pointer"
            >
              <div className="aspect-square bg-gray-50 flex items-center justify-center p-6 sm:p-8 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-300"
                />
              </div>
              <div className="bg-white p-4 sm:p-6 text-center">
                <h3 className="text-base sm:text-lg font-bold text-navy mb-2">
                  {product.name}
                </h3>
                <p className="text-xs sm:text-sm text-gray-600">{product.specs}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10 sm:mt-12 lg:mt-16">
          <Link
            to="/products"
            className="inline-block bg-white text-navy font-bold px-8 py-3 rounded-md hover:bg-gray-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            詳しく見る
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;